const PATH = "/api/v1/stay";

const ENDPOINTS = {
  STAY_BOOKINGS: "/bookings/",
  STAY_MY_BOOKINGS: "/my/bookings/",
  STAY_MY_BOOKINGS_LIST: "/my/bookings/list/",
  STAY_AVAILABILITY: "/availability/",
  STAY_OPERATORS: "/operators/",
  STAY_CHECKIN: "/checkin/",
  STAY_DESTINATIONS: "/destinations/",
  STAY_BOOKINGS_PAYMENTS: "/bookings/payments/",
  STAY_BOOKINGS_APPLY_COUPON: "/bookings/apply_coupon/",
  STAY_METADATA: "/metadata/",
  STAY_OFFERED_PRICING: "/offered/pricing/",
  STAY_MY_BOOKING_REPORT: "/my/bookings/report/",
};

export type StayEndpoints = keyof typeof ENDPOINTS;
export const StayCollection = { PATH, ENDPOINTS };
